<template>
    <EditDialog :show="visible" title="新增设备">
        <el-form size="mini" ref="form" :model="form" label-width="100px" :rules="rules">
            <el-form-item label="设备名称" prop="DoorName">
                <el-input v-model="form.DoorName"></el-input>
            </el-form-item>
            <el-form-item label="设备序列号" prop="DeviceSN">
                <el-input v-model="form.DeviceSN"></el-input>
            </el-form-item>
            <el-form-item label="设备型号" prop="DeviceModel">
                <el-input v-model="form.DeviceModel"></el-input>
            </el-form-item>
        </el-form>
        <template #button>
            <div class="dialog-footer">
                <el-button size="mini" @click="handleSave" style="margin-right: 30px" type="primary">保存</el-button>
                <el-button size="mini" @click="handleCancel">取消</el-button>
            </div>
        </template>
    </EditDialog>
</template>

<script>
export default {
    name: "DeviceEdit",
    props: {
        visible: {
            type: Boolean,
        },
    },
    data() {
        return {
            form: {
                DoorName: "",
                DeviceModel: "",
                DeviceSN: "",
            },
            rules: {
                DoorName: [{ required: true, message: "必填项", trigger: "blur" }],
                DeviceModel: [{ required: true, message: "必填项", trigger: "blur" }],
                DeviceSN: [{ required: true, message: "必填项", trigger: "blur" }],
            },
        };
    },
    methods: {
        handleSave() {
            this.$refs["form"].validate((valid) => {
                if (valid) {
                    this.$ajax.post("/Entity/AddDevice", this.form).then((res) => {
                        this.$success("操作成功");
                        this.$emit("refresh", true);
                        this.handleCancel();
                    });
                }
            });
        },
        handleCancel() {
            this.$emit("update:visible", false);
        },
    },
};
</script>

<style scoped></style>
